























import { Component, Vue } from 'vue-property-decorator';
import ActionTypes from '@/constants/action-types';

@Component
export default class EmptyMenuPopup extends Vue {
  private back(): void {
    this.$store.commit(`merchant/${ActionTypes.GetMerchantDetails}`, null);
    this.$router.push('/');
  }
}
